import { Injectable } from '@angular/core';
import { DeviceType } from 'src/app/models/device-detector.enum';

@Injectable({
  providedIn: 'root'
})
export class IOHDeviceDetectorService {
  private width: number;
  private height: number;
  private devicePixelRatio: number;
  private maxTouchPoints: number;
  private isTouchSupported: boolean;
  private resizeListener: () => void;

  constructor() {
    this.updateDimensions();
    this.devicePixelRatio = window.devicePixelRatio;
    this.maxTouchPoints = navigator.maxTouchPoints;
    this.isTouchSupported = 'ontouchstart' in window;

    this.resizeListener = () => this.updateDimensions();
    window.addEventListener('resize', this.resizeListener);
  }

  private updateDimensions() {
    this.width = window.innerWidth || document.documentElement.clientWidth;
    this.height = window.innerHeight || document.documentElement.clientHeight;
  }

  detectDeviceType(): DeviceType {
    if (this.isTablet()) {
      return DeviceType.Tablet;
    } else if (this.isMobile()) {
      return DeviceType.Mobile;
    } else if (this.isTouchDevice()) {
      return DeviceType.TouchDevice;
    } else {
      return DeviceType.Desktop;
    }
  }

  private isTablet(): boolean {
    return (
      this.width >= 600 &&
      this.width < 1200 &&
      (this.devicePixelRatio >= 1.5 || this.maxTouchPoints > 0) &&
      !this.isMobile()
    );
  }

  private isMobile(): boolean {
    return (
      this.width < 600 &&
      (this.devicePixelRatio >= 2 || this.maxTouchPoints > 0) &&
      !this.isTablet()
    );
  }

  private isTouchDevice(): boolean {
    return (
      this.isTouchSupported &&
      (this.maxTouchPoints > 0 ||
        window.matchMedia('(pointer: coarse) and (hover: none)').matches)
    );
  }

  checkIsTabletDeviceType(): boolean {
    const deviceType = this.detectDeviceType();
    switch (deviceType) {
      case DeviceType.Tablet:
        return true;
      case DeviceType.Mobile:
        return true;
      default:
        return false;
    }
  }

  checkIsTouchDevice() {
    const deviceType = this.detectDeviceType();
    return (
      deviceType === DeviceType.Tablet ||
      deviceType === DeviceType.Mobile ||
      deviceType === DeviceType.TouchDevice ||
      this.isTouchDevice()
    );
  }

  destroy() {
    window.removeEventListener('resize', this.resizeListener);
  }
}
